/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Queries_HandledInputs */

const en_ai_queries_handled = /** @type {(inputs: Ai_Queries_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Queries handled`)
};

const es_ai_queries_handled = /** @type {(inputs: Ai_Queries_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultas IA manejadas`)
};

const fr_ai_queries_handled = /** @type {(inputs: Ai_Queries_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requêtes IA traitées`)
};

const de_ai_queries_handled = /** @type {(inputs: Ai_Queries_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behandelte KI-Anfragen`)
};

const ja_ai_queries_handled = /** @type {(inputs: Ai_Queries_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIが処理した問い合わせ`)
};

const zh_ai_queries_handled = /** @type {(inputs: Ai_Queries_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 已处理的查询`)
};

const ar_ai_queries_handled = /** @type {(inputs: Ai_Queries_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استفسارات تمت معالجتها بالذكاء الاصطناعي`)
};

const id_ai_queries_handled = /** @type {(inputs: Ai_Queries_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kueri AI ditangani`)
};

const it_ai_queries_handled = /** @type {(inputs: Ai_Queries_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richieste IA gestite`)
};

const ru_ai_queries_handled = /** @type {(inputs: Ai_Queries_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросов обработано ИИ`)
};

const pt_ai_queries_handled = /** @type {(inputs: Ai_Queries_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultas IA tratadas`)
};

const ko_ai_queries_handled = /** @type {(inputs: Ai_Queries_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI가 처리한 문의 수`)
};

/**
* | output |
* | --- |
* | "AI Queries handled" |
*
* @param {Ai_Queries_HandledInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_queries_handled = /** @type {((inputs?: Ai_Queries_HandledInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Queries_HandledInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_queries_handled(inputs)
	if (locale === "es") return es_ai_queries_handled(inputs)
	if (locale === "fr") return fr_ai_queries_handled(inputs)
	if (locale === "de") return de_ai_queries_handled(inputs)
	if (locale === "ja") return ja_ai_queries_handled(inputs)
	if (locale === "zh") return zh_ai_queries_handled(inputs)
	if (locale === "ar") return ar_ai_queries_handled(inputs)
	if (locale === "id") return id_ai_queries_handled(inputs)
	if (locale === "it") return it_ai_queries_handled(inputs)
	if (locale === "ru") return ru_ai_queries_handled(inputs)
	if (locale === "pt") return pt_ai_queries_handled(inputs)
	return ko_ai_queries_handled(inputs)
});